/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The main function of the room.
 */
export const RoomFunctionDTO = {
    MASSAGE: 'MASSAGE',
    KOSMETIK: 'KOSMETIK',
    FITNESS: 'FITNESS',
    HAIR: 'HAIR',
    NAIL: 'NAIL',
    WELLNESS_SUITE: 'WELLNESS_SUITE',
    MASSAGE_SUITE: 'MASSAGE_SUITE',
    THALASSO: 'THALASSO',
    RASUL: 'RASUL',
    SOFTPACK: 'SOFTPACK',
    CABANA: 'CABANA'
} as const;
export type RoomFunctionDTO = typeof RoomFunctionDTO[keyof typeof RoomFunctionDTO];

